// extracted by mini-css-extract-plugin
var _1 = "GD4lh";
export { _1 as "disabledRow" }
